// Customers List Vuex

import state from './customerStates.js'
import * as getters from './customerGetters.js'
import * as mutations from './customerMutations.js'
import * as actions from './customerActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
